import { render, staticRenderFns } from "./restaurantMenuTable.vue?vue&type=template&id=442ee54a&"
import script from "./restaurantMenuTable.vue?vue&type=script&lang=js&"
export * from "./restaurantMenuTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports